import { config } from "common/config";

export function getLegacyRegion() {
    return config.VITE_LEGACY_REGION || "au";
}
